/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActivityProgression } from './ActivityProgression';
import {
    ActivityProgressionFromJSON,
    ActivityProgressionFromJSONTyped,
    ActivityProgressionToJSON,
    ActivityProgressionToJSONTyped,
} from './ActivityProgression';
import type { ClaimedRewardDetail } from './ClaimedRewardDetail';
import {
    ClaimedRewardDetailFromJSON,
    ClaimedRewardDetailFromJSONTyped,
    ClaimedRewardDetailToJSON,
    ClaimedRewardDetailToJSONTyped,
} from './ClaimedRewardDetail';

/**
 * 
 * @export
 * @interface ClaimRewardResponse
 */
export interface ClaimRewardResponse {
    /**
     * 
     * @type {ActivityProgression}
     * @memberof ClaimRewardResponse
     */
    progression: ActivityProgression;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimRewardResponse
     */
    rewardsGranted: boolean;
    /**
     * 
     * @type {Array<ClaimedRewardDetail>}
     * @memberof ClaimRewardResponse
     */
    rewards?: Array<ClaimedRewardDetail>;
}

/**
 * Check if a given object implements the ClaimRewardResponse interface.
 */
export function instanceOfClaimRewardResponse(value: object): value is ClaimRewardResponse {
    if (!('progression' in value) || value['progression'] === undefined) return false;
    if (!('rewardsGranted' in value) || value['rewardsGranted'] === undefined) return false;
    return true;
}

export function ClaimRewardResponseFromJSON(json: any): ClaimRewardResponse {
    return ClaimRewardResponseFromJSONTyped(json, false);
}

export function ClaimRewardResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimRewardResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'progression': ActivityProgressionFromJSON(json['progression']),
        'rewardsGranted': json['rewardsGranted'],
        'rewards': json['rewards'] == null ? undefined : ((json['rewards'] as Array<any>).map(ClaimedRewardDetailFromJSON)),
    };
}

export function ClaimRewardResponseToJSON(json: any): ClaimRewardResponse {
    return ClaimRewardResponseToJSONTyped(json, false);
}

export function ClaimRewardResponseToJSONTyped(value?: ClaimRewardResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'progression': ActivityProgressionToJSON(value['progression']),
        'rewardsGranted': value['rewardsGranted'],
        'rewards': value['rewards'] == null ? undefined : ((value['rewards'] as Array<any>).map(ClaimedRewardDetailToJSON)),
    };
}

